export class FetchRequestError<ResponseJson = any> extends Error {
  status: number;
  statusText: string;
  responseJson: ResponseJson | undefined;
  hasErrorJson: boolean;
  originalError?: string;

  constructor(statusCode: number, statusText: string, responseJson?: ResponseJson, originalError?: string) {
    super(statusText);
    this.status = statusCode;
    this.statusText = statusText;
    this.responseJson = responseJson;
    this.hasErrorJson = this.responseJson != undefined;
    this.originalError = originalError;
  }

  /**
   * Whether this error represents an unexpected system failure that warrants
   * monitoring attention (RUM error event, Sentry capture, on-call signal).
   *
   * Subclasses that represent backend-intended user-facing errors (e.g. a 400
   * carrying a message meant to be displayed to the user via toast or modal)
   * should override this to return `false`. Reporting those as system errors
   * inflates RUM/Sentry with non-actionable events because the backend has
   * already classified them as normal product flow, not failure.
   *
   * Use {@link reportUnexpectedError} in catch blocks to respect this policy.
   */
  isUnexpectedSystemError(): boolean {
    return true;
  }
}
